import { z } from 'zod';

export const dateSchema = z.coerce.date();

export const dateTypeSchema = z.enum([
  // today
  'today',
  'yesterday',
  'tomorrow',
  // weeks
  'this_week',
  'last_week',
  'next_week',

  // long days
  'last_30_days',
  'next_30_days',

  'last_60_days',
  'next_60_days',

  'last_90_days',
  'next_90_days',

  // month
  'this_month',
  'last_month',
  'next_month',

  // quarter
  'this_quarter',
  'last_quarter',
  'next_quarter',

  // year
  'this_year',
  'last_year',
  'next_year',
]);
export type DateType = z.infer<typeof dateTypeSchema>;
